import {
	SETTINGS_LOADING_STATUS,
	LOGIN_SETTINGS_GET,
	SETTINGS_GET_ERROR,
	APP_CORE_SETTINGS_GET,
	SETTINGS_SECURITY_ERROR,
	CHAPTERS_GET,
	STYLE_SETTINGS_GET,
	CI_CD_SETTINGS_GET,
	CORE_SETTINGS_GET,
	WEB_SETTINGS_GET,
	USER_SETTINGS_GET,
	BACK_USER_SETTINGS_GET,
	EVENT_SETTINGS_GET,
	SETTINGS_URL_GET,
	SETTINGS_REGISTRATION_FIELDS_GET,
	SETTINGS_REGISTRATION_FIELDS_LOADING,
	SETTINGS_GET_LIST_FIELDS,
	SETTINGS_GET_LIST_FIELDS_LOADING,
	SETTINGS_SET_DWH_DISABLED,
	SETTINGS_INC_DWH_FAIL,
	SETTINGS_RESET_DWH_FAIL,
} from './types'
import { getParsedMenu, getBaseMenuItems, getNormalizedChips } from '@/utils/helpers'

const initialState = {
	loading: false,
	errors: [],
	login: null,
	settings: [],
	app_core: null,
	chapters: {},
	styles: null,
	user: null,
	core: null,
	ci_cd: null,
	web: null,
	event: null,
	back_user: null,
	url: null,
	dwh: null,
	registration_fields: null,
	fields_loading: false,
	listDataBySource: {},
	listDataBySourceLoading: false,
	paginationState: {},
	dwhDisabled: false,
	dwhFailCount: 0,
}

export const state = { ...initialState }

export default {
	[SETTINGS_SET_DWH_DISABLED]: (state, v) => {
		state.dwhDisabled = Boolean(v)
	},
	[SETTINGS_INC_DWH_FAIL]: (state) => {
		state.dwhFailCount += 1
	},
	[SETTINGS_RESET_DWH_FAIL]: (state) => {
		state.dwhFailCount = 0
	},
	[SETTINGS_GET_LIST_FIELDS_LOADING]: (state, { source, loading }) => {
		state.listDataBySourceLoading = {
			...state.listDataBySourceLoading,
			[source]: loading,
		}
	},
	[SETTINGS_GET_LIST_FIELDS]: (state, { source, data, headers }) => {
		const current = state.listDataBySource[source] || []
		state.listDataBySource = {
			...state.listDataBySource,
			[source]: [...current, ...data],
		}
		state.paginationState = {
			...state.paginationState,
			[source]: {
				page: Number(headers['x-pagination-current-page']),
				pageCount: Number(headers['x-pagination-page-count']),
			},
		}
	},
	[SETTINGS_LOADING_STATUS]: (state, status) => {
		state.loading = status
	},

	[LOGIN_SETTINGS_GET]: (state, payload) => {
		state.login = payload
	},

	[CHAPTERS_GET]: (state, payload) => {
		state.chapters = payload.initChapters
	},

	[APP_CORE_SETTINGS_GET]: (state, payload) => {
		const { app_menu } = payload

		const appMenu = getParsedMenu(app_menu)

		const baseMenuItems = getBaseMenuItems(appMenu, [
			'threads',
			'events',
			'resources',
			'forums',
			'users',
			'directory',
			'rss-feed',
			'web-view',
		])

		state.app_core = {
			...payload,
			app_menu: appMenu,
			appMenuNormalized: {
				baseMenuItems,
			},
		}
	},

	[EVENT_SETTINGS_GET]: (state, payload) => {
		state.event = {
			...payload,
			normalizedChips: getNormalizedChips(payload, 'event_filter_name', 'event_filter'),
		}
	},

	[STYLE_SETTINGS_GET]: (state, payload) => {
		state.styles = payload
	},

	[BACK_USER_SETTINGS_GET]: (state, payload) => {
		state.back_user = payload
	},

	[USER_SETTINGS_GET]: (state, payload) => {
		state.user = {
			...payload,
			normalizedChips: getNormalizedChips(payload, 'filter_chips_title', 'filter_chips'),
		}
	},
	[CI_CD_SETTINGS_GET]: (state, payload) => {
		state.ci_cd = payload
	},

	[CORE_SETTINGS_GET]: (state, payload) => {
		state.core = payload
	},

	[WEB_SETTINGS_GET]: (state, payload) => {
		state.web = payload
	},

	[SETTINGS_GET_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},

	[SETTINGS_SECURITY_ERROR]: (state, error) => {
		state.errors = [...state.errors, error]
	},
	[SETTINGS_URL_GET]: (state, payload) => {
		state.url = payload
	},
	[SETTINGS_REGISTRATION_FIELDS_GET]: (state, payload) => {
		state.registration_fields = payload
	},
	[SETTINGS_REGISTRATION_FIELDS_LOADING]: (state, payload) => {
		state.fields_loading = payload
	},
}
